<template>
    <div class="ui-checkbox">
        <input ref="cbx" type="checkbox" v-model="internalValue" :value="value" />
        <label @click="$refs.cbx.click()">
            <svg class="unchecked" width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-444.000000, -762.000000)" stroke="#1A76BC">
                        <g transform="translate(0.000000, 625.000000)">
                            <g transform="translate(395.000000, 100.000000)">
                                <rect x="50" y="38" width="13" height="13" rx="2"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

            <svg class="checked" width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-444.000000, -725.000000)" stroke="#1A76BC">
                        <g transform="translate(0.000000, 625.000000)">
                            <g transform="translate(395.000000, 100.000000)">
                                <g transform="translate(0.000000, 1.000000)">
                                    <g transform="translate(50.000000, 0.000000)">
                                        <polyline stroke-width="2" stroke-linecap="round" stroke-linejoin="round" points="3 6.65652627 5.36889153 9 10.0886844 4"></polyline>
                                        <rect x="0" y="0" width="13" height="13" rx="2"></rect>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

            {{ label }}
        </label>
    </div>
</template>

<script>
    export default {
        name: 'ui-checkbox',
        model: {
            prop: 'checked'
        },
        props: ['value', 'checked', 'label'],
        computed: {
            internalValue: {
                get() {
                    return this.checked
                },
                set(v) {
                    this.$emit("input", v)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .ui-checkbox {
        [type="checkbox"] {
            opacity: 0;
            margin: 0;
            position: absolute;

            &:checked ~ label {
                .checked {
                    opacity: 1;
                }
                .unchecked {
                    opacity: 0;
                }
            }
        }

        svg {
            position: absolute;
            left: 0;
            top: .4rem;
            display: block;
            opacity: 0;
            -webkit-transform: translate3d(0, 0, 0);

            &.unchecked {
                opacity: 1;
            }
        }

        label {
            display: inline-block;
            padding-left: 1.875rem;
            position: relative;
            margin: 0;
            cursor: pointer;
            font-size: .875em;
        }
    }

</style>